module.exports = __webpack_public_path__ + "static/media/BINOCULARES.952452ef.svg";